<template>
    <div v-if="sizes" class="table">
        <div v-if="hasGender" class="gender-switcher mt-3 mb-5">
            <div @click="current = 'woman'" class="mr-3" :class="{'active': current === 'woman'}"><span>Женщинам</span>
            </div>
            <div @click="current = 'man'" :class="{'active': current === 'man'}"><span>Мужчинам</span></div>
        </div>
        <table>
            <thead>
            <tr>
                <th v-for="(value, key) in tableSizes[0]" :key="`key-${key}`">{{ labels[key] }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(size, i) in tableSizes" :key="`key-${i}`">
                <td v-for="(s, k) in size" :key="k">{{ s }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        hasGender: {
            type: Boolean
        },
        sizes: {
            type: Object|Array,
        },
        labels: {
            type: Object|Array,
        }
    },
    data() {
        return {
            current: 'woman',
            woman: 1,
            man: 2,
        }
    },
    computed: {
        tableSizes() {
            if (this.hasGender) {
                if (this.current === 'woman') {
                    return this.sizes['g_' + this.woman] !== undefined ? this.sizes['g_' + this.woman] : [];
                } else if (this.current === 'man') {
                    return this.sizes['g_' + this.man] !== undefined ? this.sizes['g_' + this.man] : [];
                }
            }

            return this.sizes;
        }
    }
}
</script>
